import { IIntegrationPartner, ipEmailClients, IpNames } from "../../../interfaces/interfaces";
import styles from './emailOtpHelper.module.scss';
import { AiOutlineSetting as SettingIcon } from 'react-icons/ai';
import { HiChevronRight as RightArrowIcon } from 'react-icons/hi';
import { MdContentCopy as CopyIcon } from "react-icons/md";
import { FaCheck as CheckIcon } from 'react-icons/fa'
import { useEffect, useRef, useState } from "react";
import { IoMdOptions as SettingsIcon } from 'react-icons/io'
import { RiMailFill as MailIcon } from 'react-icons/ri'
import _ from "lodash";
import {
	formatNoReplyEmail,
	getEmailDisplaySeparator,
	usesHasTheWordsField,
	usesSubjectOrBodyField
} from "../../../components/functions/ipConfig";


interface EmailStepInfo {
	title: JSX.Element;
	gif?: string;
	container?: JSX.Element;
};

type TextCopyProps = {
	text: string;
}

export const meritoHelpDeskEmail = "helpdesk@clickmerito.com"

export const TextCopy = ({ text }) => {
	const [copied, setCopied] = useState(false);
	const textRef = useRef<HTMLDivElement>(null);
	const [fixedWidth, setFixedWidth] = useState<string>("auto");

	useEffect(() => {
		if (textRef.current) {
			setFixedWidth(`${textRef.current.offsetWidth}px`);
		}
	}, [text]); // Only update width when the original text changes

	const handleCopy = async () => {
		try {
			await navigator.clipboard.writeText(text);
			setCopied(true);

			// Reset copied state after 2 seconds
			setTimeout(() => setCopied(false), 1000);
		} catch (err) {
			console.error("Failed to copy text:", err);
		}
	};

	return (
		<div className={styles.textCopyRootContainer} onClick={handleCopy}>
			<div ref={textRef} className={styles.hiddenText}>
				<div>
					{text}
				</div>
				<div className={styles.iconContainer}>
					<CopyIcon />
				</div>
			</div>

			<div className={styles.textContainer} style={{ width: fixedWidth }}>
				{copied ? <>
					Copied
					<span className={styles.iconContainer}><CheckIcon /></span>
				</> :
					<>
						<div>
							{text}
						</div>
						<div className={styles.iconContainer}>
							<CopyIcon />
						</div>
					</>
				}
			</div>
		</div>
	);
}


export const emailOtpStepInfo = (ip: IIntegrationPartner) => {
	const shortIpName = ipShortNames[ip.companyName] ?? ip.companyName;

	const ipGifs = {
		[IpNames.blinkitB2b]: {
			[ipEmailClients.gmail]: {
				5: "https://assets.clickmerito.com/emailOtpSteps/gmail+-+blinkit+b2b+-+step+3.mp4",
				6: "https://assets.clickmerito.com/emailOtpSteps/gmail+-+blinkit+b2b+-+step+4.mp4",
			},
			[ipEmailClients.outlook]: {
				2: "https://assets.clickmerito.com/emailOtpSteps/outlook+-+blinkit+-+step+1.mp4",
				3: "https://assets.clickmerito.com/emailOtpSteps/outlook+-+blinkit+b2b+-+step+2.mp4",
				4: "https://assets.clickmerito.com/emailOtpSteps/outlook+-+blinkit+b2b+-+step+3.mp4",
			},
		},
		[IpNames.swiggyInstamart]: {
			[ipEmailClients.gmail]: {
				5: "https://assets.clickmerito.com/emailOtpSteps/gmail+-+swiggy+im+-+2+-+step+3_v2.mp4",
				6: "https://assets.clickmerito.com/emailOtpSteps/gmail+-+swiggy+im+-+2+-+step+4_v2.mp4",
			},
			[ipEmailClients.outlook]: {
				2: "https://assets.clickmerito.com/emailOtpSteps/outlook+-+step+1.mp4",
				3: "https://assets.clickmerito.com/emailOtpSteps/outlook+-+swiggy+im+-+2+-+step+2_v2.mp4",
				4: "https://assets.clickmerito.com/emailOtpSteps/outlook+-+swiggy+im+-+2+-+step+3_v2.mp4",
			},
		},
		[IpNames.blinkitMarketplace]: {
			[ipEmailClients.gmail]: {
				5: "https://assets.clickmerito.com/emailOtpSteps/gmail+-+blinkit+marketplace+-+step+3.mp4",
				6: "https://assets.clickmerito.com/emailOtpSteps/gmail+-+blinkit+marketplace+-+step+4.mp4",
			},
			[ipEmailClients.outlook]: {
				2: "https://assets.clickmerito.com/emailOtpSteps/outlook+-+step+1.mp4",
				3: "https://assets.clickmerito.com/emailOtpSteps/outlook+-+blinkit+marketplace+-+step+2.mp4",
				4: "https://assets.clickmerito.com/emailOtpSteps/outlook+-+blinkit+marketplace+-+step+3.mp4",
			},
		},
		[IpNames.flipkartSeller]: {
			[ipEmailClients.gmail]: {
				5: "https://assets.clickmerito.com/emailOtpSteps/gmail+-+flipkart+seller+-+step+3_medium+compression.mp4",
				6: "https://assets.clickmerito.com/emailOtpSteps/gmail+-+flipkart+seller+-+step+4_medium+compression.mp4",
			},
			[ipEmailClients.outlook]: {
				2: "https://assets.clickmerito.com/emailOtpSteps/outlook+-+step+1.mp4",
				3: "https://assets.clickmerito.com/emailOtpSteps/outlook+-+flipkart+seller+-+step+2_medium+compression_v2.mp4",
				4: "https://assets.clickmerito.com/emailOtpSteps/outlook+-+flipkart+seller+-+step+3_medium+compression.mp4",
			},
		},
		[IpNames.nykaa]: {
			[ipEmailClients.gmail]: {
				5: "https://assets.clickmerito.com/emailOtpSteps/gmail+-+nykaa+-+step+3.mp4",
				6: "https://assets.clickmerito.com/emailOtpSteps/gmail+-+nykaa+-+step+4.mp4",
			},
			[ipEmailClients.outlook]: {
				2: "https://assets.clickmerito.com/emailOtpSteps/outlook+-+step+1.mp4",
				3: "https://assets.clickmerito.com/emailOtpSteps/outlook+-+nykaa+-+step+2.mp4",
				4: "https://assets.clickmerito.com/emailOtpSteps/outlook+-+nykaa+-+step+3.mp4",
			},
		},
		[IpNames.blinkitAds]: {
			[ipEmailClients.gmail]: {
				5: "https://assets.clickmerito.com/emailOtpSteps/gmail+-+blinkit+ads+-+step+3.mp4",
				6: "https://assets.clickmerito.com/emailOtpSteps/gmail+-+blinkit+ads+-+step+4.mp4",
			},
			[ipEmailClients.outlook]: {
				2: "https://assets.clickmerito.com/emailOtpSteps/outlook+-+step+1.mp4",
				3: "https://assets.clickmerito.com/emailOtpSteps/outlook+-+blinkit+ads+-+step+2.mp4",
				4: "https://assets.clickmerito.com/emailOtpSteps/outlook+-+blinkit+ads+-+step+3.mp4",
			},
		},
		[IpNames.zepto]: {
			[ipEmailClients.gmail]: {
				5: "https://assets.clickmerito.com/emailOtpSteps/gmail+-+zepto+-+step+3.mp4",
				6: "https://assets.clickmerito.com/emailOtpSteps/gmail+-+zepto+-+step+4.mp4",
			},
			[ipEmailClients.outlook]: {
				2: "https://assets.clickmerito.com/emailOtpSteps/outlook+-+step+1.mp4",
				3: "https://assets.clickmerito.com/emailOtpSteps/outlook+-+zepto+-+step+2.mp4",
				4: "https://assets.clickmerito.com/emailOtpSteps/outlook+-+zepto+-+step+3.mp4",
			},
		},
	};

	const getGifUrl = (ipName: string, emailClient: string, step: number) => {
		return _.get(ipGifs, [ipName, emailClient, step], "");
	}

	const IconContainer = ({ icon }) => {
		return <div className={styles.iconContainer}>
			{icon}
		</div>
	}


	const noReplySplitEmail = () => {
		const displaySeparator = getEmailDisplaySeparator(ip?.companyName);

		if (displaySeparator === 'AND') {
			const splitEmail = ip?.noReplyEmail?.split(',');
			return (
				<>
					<TextCopy text={splitEmail[0]} />
					and
					<TextCopy text={splitEmail[1]} />
				</>
			)
		} else {
			return <TextCopy text={ip?.noReplyEmail} />
		}
	}



	return {
		0: {
			title: <>Connect Your {shortIpName} Account</>,
		},
		gmail: {
			2: {
				title: <>Set Up Auto-Forwarding Email</>,
				gif: "https://assets.clickmerito.com/emailOtpSteps/gmail+-+blinkit+-+step+1.mp4",
				container: (
					<>
						<div className={styles.otpStepList}>
							<div className={styles.stepItemContainer}>
								<div className={styles.stepNumber}>1.</div>
								<div className={styles.stepTextContainer}>
									<div>Login to your {shortIpName} registered email account.</div>
								</div>
							</div>
							<div className={styles.stepItemContainer}>
								<div className={styles.stepNumber}>2.</div>
								<div className={styles.stepTextContainer}>
									<div>In the top right, click Settings</div>
									<div className={styles.iconContainer}>
										<SettingIcon />
									</div>
									<div className={styles.iconContainer}>
										<RightArrowIcon />
									</div>
									<div>
										<b>See all settings.</b>
									</div>
								</div>
							</div>
						</div>
					</>
				),
			},
			3: {
				title: <>Set Up Auto-Forwarding Email</>,
				container: (
					<>
						<div className={styles.otpStepList}>
							<div className={styles.stepItemContainer}>
								<div className={styles.stepNumber}>1.</div>
								<div className={styles.stepTextContainer}>
									<div>
										Click the <b>Forwarding</b> tab. In the "Forwarding"
										section, click <b>Add a forwarding address.</b>
									</div>
								</div>
							</div>
							<div className={styles.stepItemContainer}>
								<div className={styles.stepNumber}>2.</div>
								<div className={styles.stepTextContainer}>
									<div>Enter</div>
									<TextCopy text={meritoHelpDeskEmail} />.<div>Click Next</div>
									<div className={styles.iconContainer}>
										<RightArrowIcon />
									</div>
									<div>Proceed</div>
								</div>
							</div>
						</div>
					</>
				),
				gif: "https://assets.clickmerito.com/emailOtpSteps/gmail+-+blinkit+-+step+2.mp4",
			},
			5: {
				title: <>Create Forwarding Filter</>,
				container: (
					<>
						<div className={styles.otpStepList}>
							<div className={styles.stepItemContainer}>
								<div className={styles.stepNumber}>1.</div>
								<div className={styles.stepTextContainer}>
									<div>
										In the <b>search box at the top</b>, click Show search
										options
									</div>
									<div className={styles.iconContainer}>
										<SettingsIcon />
									</div>
								</div>
							</div>
							<div className={styles.stepItemContainer}>
								<div className={styles.stepNumber}>2.</div>
								<div className={styles.stepTextContainer}>
									<div>
										In{" "}
										{usesHasTheWordsField(ip?.companyName) ? (
											<b>Has the words</b>
										) : (
											"the From"
										)}{" "}
										field, enter
									</div>
									<TextCopy
										text={formatNoReplyEmail(ip?.noReplyEmail, ip?.companyName, 'gmail')}
									/>
									.
									<div>
										Next, click <b>Create filter.</b>
									</div>
								</div>
							</div>
						</div>
					</>
				),
				gif: getGifUrl(ip.companyName, ipEmailClients.gmail, 5),
			},
			6: {
				title: <>Create Forwarding Filter</>,
				container: (
					<>
						<div className={styles.otpStepList}>
							<div className={styles.stepItemContainer}>
								<div className={styles.stepNumber}>1.</div>
								<div className={styles.stepTextContainer}>
									<div>
										Check the <b>Forward it to</b> checkbox, and <b>select</b>{" "}
										{`${meritoHelpDeskEmail}`}.
									</div>
									{/* <div className={styles.iconContainer}>
										<SettingsIcon />
									</div> */}
								</div>
							</div>
							<div className={styles.stepItemContainer}>
								<div className={styles.stepNumber}>2.</div>
								<div className={styles.stepTextContainer}>
									<div>
										Click <b>Create filter</b>.
									</div>
								</div>
							</div>
						</div>
					</>
				),
				gif: getGifUrl(ip.companyName, ipEmailClients.gmail, 6),
			},
		},
		outlook: {
			2: {
				title: <>Set Up Auto-Forwarding</>,
				container: (
					<>
						<div className={styles.otpStepList}>
							<div className={styles.stepItemContainer}>
								<div className={styles.stepNumber}>1.</div>
								<div className={styles.stepTextContainer}>
									<div>
										Login to your {`${shortIpName}`} registered email account.
									</div>
								</div>
							</div>
							<div className={styles.stepItemContainer}>
								<div className={styles.stepNumber}>2.</div>
								<div className={styles.stepTextContainer}>
									<div>
										In the top right, click <b>Settings</b>
									</div>
									<IconContainer icon={<SettingsIcon />} />
									<IconContainer icon={<RightArrowIcon />} />
									<div>
										<b>Mail</b>
									</div>
									<IconContainer icon={<MailIcon />} />
									<IconContainer icon={<RightArrowIcon />} />
									<div>
										<b>Rules</b>.
									</div>
								</div>
							</div>
						</div>
					</>
				),
				gif: getGifUrl(ip.companyName, ipEmailClients.outlook, 2),
			},
			3: {
				title: <>Set Up Auto-Forwarding</>,
				container: (
					<>
						<div className={styles.otpStepList}>
							<div className={styles.stepItemContainer}>
								<div className={styles.stepNumber}>1.</div>
								<div className={styles.stepTextContainer}>
									<div>
										Click <b>Add New Rule</b> and name it
									</div>
									<TextCopy text={`${ip?.companyName} OTP Redirects to Merito`} />
								</div>
							</div>
							<div className={styles.stepItemContainer}>
								<div className={styles.stepNumber}>2.</div>
								<div className={styles.stepTextContainer}>
									<div>
										Set the condition:{" "}
										{usesSubjectOrBodyField(ip?.companyName) ? (
											<b>Subject or body includes</b>
										) : (
											<b>From</b>
										)}{" "}
									</div>
									{/* <IconContainer icon={<SettingIcon />} /> */}
									{noReplySplitEmail()}
								</div>
							</div>
						</div>
					</>
				),
				gif: getGifUrl(ip.companyName, ipEmailClients.outlook, 3),
			},
			4: {
				title: <>Set Up Auto-Forwarding</>,
				container: (
					<>
						<div className={styles.otpStepList}>
							<div className={styles.stepItemContainer}>
								<div className={styles.stepNumber}>1.</div>
								<div className={styles.stepTextContainer}>
									<div>
										Set the action: <b>Redirect To</b>
									</div>
									<TextCopy text={meritoHelpDeskEmail} />
								</div>
							</div>
							<div className={styles.stepItemContainer}>
								<div className={styles.stepNumber}>2.</div>
								<div className={styles.stepTextContainer}>
									<div>
										Click <b>Save</b>.
									</div>
								</div>
							</div>
						</div>
					</>
				),
				gif: getGifUrl(ip.companyName, ipEmailClients.outlook, 4),
			},
		},
		others: {
			2: {
				title: <>Connect Your {shortIpName} Account</>,
				gif: "",
				container: (
					<div className={styles.otherStepRootContainer}>
						<div className={styles.infoContainer}>
							<div className={styles.title}>
								To connect {shortIpName}, Merito requires you to enable email
								forwarding for {shortIpName} OTPs. <br /> Follow these general steps
								to set up auto-forwarding:
							</div>
							<div className={styles.stepListContainer}>
								<div className={styles.stepItemContainer}>
									<div className={styles.numberContainer}>1</div>
									<div className={styles.textRootContainer}>
										<div className={styles.textContainer}>
											Login to your{" "}
											<b>{shortIpName} registered email address.</b>
										</div>
									</div>
								</div>
								<div className={styles.stepItemContainer}>
									<div className={styles.numberContainer}>2</div>
									<div className={styles.textRootContainer}>
										<div className={styles.textContainer}>
											Find Settings. Look for “Settings”, “Rules”, or
											“Filters”.
										</div>
									</div>
								</div>
								<div className={styles.stepItemContainer}>
									<div className={styles.numberContainer}>3</div>
									<div className={styles.textRootContainer}>
										<div className={styles.textContainer}>
											Add a new rule/filter to <b>forward emails:</b>
										</div>
										<div className={styles.textContainer}>
											<div>
												<b>
													{ip?.companyName
														? `Subject or body has the words`
														: "From"}
												</b>
											</div>
											<TextCopy text={ip?.noReplyEmail} />
										</div>
										<div className={styles.textContainer}>
											<div className={styles.marginRight}>
												<b>To</b>
											</div>
											<TextCopy text={meritoHelpDeskEmail} />
										</div>
									</div>
								</div>
								<div className={styles.stepItemContainer}>
									<div className={styles.numberContainer}>4</div>
									<div className={styles.textRootContainer}>
										Save and enable the rule.
									</div>
								</div>
							</div>
						</div>
					</div>
				),
			},
		},
	};
}

export const ipShortNames = {
	[IpNames.blinkitB2b]: 'Blinkit',
}

type Props = {
	ip: IIntegrationPartner,
	stepInfo: EmailStepInfo
}

export const EmailOtpGifSteps = ({ ip, stepInfo }: Props) => {

	return (
		<div className={styles.stepsRootContainer}>
			<div className={styles.topContainer}>
				{stepInfo?.container}
			</div>
			{stepInfo?.gif ? <div className={styles.videoContainer}>
				<video key={stepInfo?.gif} autoPlay loop muted playsInline>
					<source src={stepInfo?.gif} type="video/mp4" />
				</video>
			</div> : null}
		</div>
	);
}

export default EmailOtpGifSteps